import { Disposable } from './disposable.js';

/**
 * A simple emitter that can be used to subscribe to an event
 */
export class Emitter<Value> {
	private listeners: ((evt: Value) => void)[] = [];
	subscribe(handler: (evt: Value) => void, first = false): Disposable {
		if (first) {
			this.listeners.unshift(handler);
		} else {
			this.listeners.push(handler);
		}
		return new Disposable(() => {
			const idx = this.listeners.indexOf(handler);
			if (idx !== -1) this.listeners.splice(idx, 1);
		});
	}
	emit(value: Value): void {
		for (const listener of [...this.listeners]) {
			listener(value);
		}
	}
	dispose(): void {
		this.listeners.length = 0;
	}
}
